/* eslint-disable no-new */
import flickityAsNavFor from "flickity-as-nav-for";
import FlickityClass from "common/utils/ui/flickity-class";
import EventClass from "common/utils/ui/event-class";

const initSlider = async () => {
  const slider = new FlickityClass(
    ".js-made-apparel-benefits-carousel",
    {
      selectedAttraction: 0.01,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 5000,
      pauseAutoPlayOnHover: true
    },
    {
      library: flickityAsNavFor
    }
  );

  await slider.initFlickity();

  new EventClass({
    eventSelector: ".js-made-apparel-benefits-carousel-prev",
    eventCallback: () => slider.flickity.previous()
  });

  new EventClass({
    eventSelector: ".js-made-apparel-benefits-carousel-next",
    eventCallback: () => slider.flickity.next()
  });
};

export default () => {
  initSlider();
};
